import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Avatar, Collapse, Divider, ListItem, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { styled } from "@mui/material/styles";
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";

// Import SVG Icons
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import nucliqLogo from '../../assets/png/nucliqlogoblack.png';
import BatchesBlackIcon from '../../assets/svg/BatchesBlackIcon.svg';
import BatchesWhiteIcon from '../../assets/svg/BatchesWhiteIcon.svg';

import DataAnalysisBlackIcon from '../../assets/png/DataAnalysisBlackIcon.png';
import DataAnalysisWhiteIcon from '../../assets/png/DataAnalysisWhiteIcon.png';

import InventoryBlackIcon from '../../assets/png/inventoryBlack.png';
import InventoryWhiteIcon from '../../assets/png/inventoryWhite.png';
import LabBlackIcon from '../../assets/png/labBlack.png';
import LabWhiteIcon from '../../assets/png/labWhite.png';
import LogisticsBlackIcon from '../../assets/png/logistics-delivery.png';
import LogisticsWhiteIcon from '../../assets/png/logistics-deliveryWhiteIcon.png';
import ClientsBlackIcon from '../../assets/svg/ClientsBlackIcon.svg';
import ClientsWhiteIcon from '../../assets/svg/ClientsWhiteIcon.svg';
import copyrightLogo from '../../assets/svg/copyright.svg';
import DashboardIcon from '../../assets/svg/DashboardIcon.svg';
import DashboardWhiteIcon from '../../assets/svg/DashboardWhiteIcon.svg';
// import DataAnalysisBlackIcon from '../../assets/svg/DataAnalysisUpdatedIcon.svg';
import KitsBlackIcon from '../../assets/svg/KitsBlackIcon.svg';
import KitsWhiteIcon from '../../assets/svg/KitsWhiteIcon.svg';
import LogoutIcon from '../../assets/svg/LogOutIcon.svg';
import ManagementBlackIcon from '../../assets/svg/ManagementBlackIcon.svg';
import ManagementWhiteIcon from '../../assets/svg/ManagementWhiteIcon.svg';
import MenuIcon from '../../assets/svg/MenuIcon.svg';
import MetaDataBalckIcon from '../../assets/svg/MetaDataIconBlack.svg';
import MetaDataWhiteIcon from '../../assets/svg/MetaDataIconWhite.svg';
import OrdersBlackIcon from '../../assets/svg/OrdersBlackIcon.svg';
import OrdersWhiteIcon from '../../assets/svg/OrdersWhiteIcon.svg';
import { PATH } from '../../constants/PATH/Path';
import { onLogout, setStageMasterName, setStageName } from '../../redux/common.slice';
import { persistor } from '../../redux/store';
import { useLogoutMutation } from '../../services/Login/Authendication.Api';
import { useGetStageMasterNameMutation } from '../../services/Scripts/Scripts.Api';
import { SnackbarContext } from '../../shared/snackbar/Snackbar';
import '../containers/container.css';

// Drawer width
const drawerWidth = 300;

// MUI Custom Styles for opened/closed states
const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

// Styled Drawer Header for layout consistency
const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}));

const DrawerMainContainer = styled("div")(({ theme }) => ({
    position: "sticky",
    top: 0,
    zIndex: theme.zIndex.appBar,
    backgroundColor: theme.palette.background.default,
}))

// Styled Drawer component
const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    marginRight: "-20px",
    boxSizing: "border-box",
    ...(open && {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
    }),
}));

// Sidebar component
export default function Sidebar() {
    const location = useLocation();
    const [open, setOpen] = React.useState(true);
    const [dataAnalysisOpen, setDataAnalysisOpen] = useState(() => {
        const savedValue = localStorage.getItem('openDA');
        return savedValue ? JSON.parse(savedValue) : false;
    });
    const [laboratoryOpen, setLaboratoryOpen] = useState(() => {
        const savedValue = localStorage.getItem('openLaboratory');
        return savedValue ? JSON.parse(savedValue) : false;
    });
    const [logisticsOpen, setLogisticsOpen] = useState(() => {
        const savedValue = localStorage.getItem('openLogistics');
        return savedValue ? JSON.parse(savedValue) : false;
    });
    const [inventoryOpen, setInventoryOpen] = useState(() => {
        const savedValue = localStorage.getItem('openInventory');
        return savedValue ? JSON.parse(savedValue) : false;
    });
    const [selectedItem, setSelectedItem] = React.useState(null); // Added state for selected item
    const [selectedSubItem, setSelectedSubItem] = useState(() =>
        localStorage.getItem('selectedSubItem') || ''
    );

    const [loading, setLoading] = React.useState(true);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { displaySnackbar } = useContext(SnackbarContext);
    const [logoutApi] = useLogoutMutation();

    const { userDetails } = useSelector((state) => state?.common);
    const { menus } = useSelector((state) => state?.common);

    const userName = userDetails?.userName || '';
    const avatarLetter = userName.charAt(0).toUpperCase();

    const userMenu = menus || [];
    const [menuItems, setMenuItems] = useState([]);


    const [stageMasterData, setStageMasterData] = useState([])

    const [GetAllStages] = useGetStageMasterNameMutation();

    const fetchStages = async () => {
        try {
            const response = await GetAllStages().unwrap();
            setStageMasterData(response.data || []);

        } catch (err) {
            console.error('Failed to fetch Countries : ', err)
        }
    };

    useEffect(() => {
        fetchStages();
    }, [])

    useEffect(() => {
        const menuIcons = {
            Dashboard: location.pathname === PATH.DASHBOARD ? DashboardWhiteIcon : DashboardIcon,
            Laboratory: (
                location.pathname === PATH.BATCHES ||
                location.pathname === PATH.CREATE_BATCH ||
                location.pathname === PATH.UPDATE_BATCH ||
                location.pathname === PATH.LIST_OF_BARCODES ||
                location.pathname === PATH.CREATE_SAMPLE
            ) ? LabWhiteIcon : LabBlackIcon,

            Logistics: (
                location.pathname === PATH.ORDERS ||
                location.pathname === PATH.CREATE_ORDER ||
                location.pathname === PATH.UPDATE_ORDER ||
                location.pathname === PATH.KITS ||
                location.pathname === PATH.CLIENTS ||
                location.pathname === PATH.CREATE_CLIENT ||
                location.pathname === PATH.UPDATE_CLIENT
            ) ? LogisticsWhiteIcon : LogisticsBlackIcon,

            Inventory: (
                location.pathname === PATH.FREEZER ||
                location.pathname === PATH.LAB_CONSUMABLES ||
                location.pathname === PATH.GUTCHECK_SUPPLIES ||
                location.pathname === PATH.HISTORY_OF_GUTCHECK_SUPPLIES ||
                location.pathname === PATH.HISTORY_OF_LAB_CONSUMABLES
            ) ? InventoryWhiteIcon : InventoryBlackIcon,

            Metadata: location.pathname === PATH.METADATA ? MetaDataWhiteIcon : MetaDataBalckIcon,

            "Data Analysis": (location.pathname === PATH.BIOINFORMATICS ||
                location.pathname === PATH.ML_ANALYSIS ||
                location.pathname === PATH.R_ANALYSIS ||
                location.pathname === PATH.REPORT_GENERATION ||
                location.pathname === PATH.QUALITY_CONTROL ||
                location.pathname === PATH.SAMPLES_BIOINFORMATICS ||
                location.pathname === PATH.SAMPLES_ML_ANALYSIS ||
                location.pathname === PATH.SAMPLES_R_ANALYSIS ||
                location.pathname === PATH.SAMPLES_REPORT_GENERATION ||
                location.pathname === PATH.SAMPLES_QUALITY_CONTROL ||
                location.pathname === PATH.SCRIPTS ||
                location.pathname === PATH.UPLOAD_SCRIPT ||
                location.pathname === PATH.SCRIPT_HISTORY ||
                location.pathname === PATH.REPORT_TEMPLATE ||
                location.pathname === PATH.CREATE_REPORT_TEMPLATE ||
                location.pathname === PATH.UPDATE_REPORT_TEMPLATE ||
                location.pathname === PATH.REPORT_TEMPLATE_HISTORY ||
                location.pathname === PATH.DATA_CURATION ||
                location.pathname === PATH.UPLOAD_DATA_CURATION ||
                location.pathname === PATH.DATA_CURATION_HISTORY ||
                location.pathname === PATH.DATA_ANALYSIS) ? DataAnalysisWhiteIcon : DataAnalysisBlackIcon,
            Management: (
                location.pathname === PATH.MANAGEMENT ||
                location.pathname === PATH.USERS ||
                location.pathname === PATH.CREATE_USER ||
                location.pathname === PATH.UPDATE_USER ||
                location.pathname === PATH.ROLES ||
                location.pathname === PATH.UPDATE_ROLE_PERMISSION ||
                location.pathname === PATH.PRODUCTS ||
                location.pathname === PATH.CREATE_PRODUCTS ||
                location.pathname === PATH.UPDATE_PRODUCTS ||
                location.pathname === PATH.AUDIT_LOG
            ) ? ManagementWhiteIcon : ManagementBlackIcon,

            Clients: (
                location.pathname === PATH.CLIENTS ||
                location.pathname === PATH.CREATE_CLIENT ||
                location.pathname === PATH.UPDATE_CLIENT
            ) ? ClientsWhiteIcon : ClientsBlackIcon,
            Kits: location.pathname === PATH.KITS ? KitsWhiteIcon : KitsBlackIcon,
            Batches: (
                location.pathname === PATH.BATCHES ||
                location.pathname === PATH.CREATE_BATCH ||
                location.pathname === PATH.UPDATE_BATCH ||
                location.pathname === PATH.LIST_OF_BARCODES ||
                location.pathname === PATH.CREATE_SAMPLE
            ) ? BatchesWhiteIcon : BatchesBlackIcon,
            Orders: (
                location.pathname === PATH.ORDERS ||
                location.pathname === PATH.CREATE_ORDER ||
                location.pathname === PATH.UPDATE_ORDER
            ) ? OrdersWhiteIcon : OrdersBlackIcon,
        };

        const fetchMenu = async () => {
            try {
                setLoading(true);
                const mappedItems = userMenu?.filter(data => (data?.isDataAnalysis === false &&
                    data?.isLaboratory === false &&
                    data?.isLogistics === false &&
                    data?.isInventory === false) &&
                    (data?.menuId !== "bc8aa031-27f2-44ee-8f7f-cf6edda2ba1a" &&
                        data?.menuId !== "9fa10054-516d-4ed9-b04e-2c746a8d59a4" &&
                        data?.menuId !== "7b3d7c97-3f52-4565-9829-6e58a23de490")
                )?.map((menu) => ({
                    text: menu?.menuName,
                    path: `/${menu?.menuName.toLowerCase().replace(/\s+/g, '-')}`,
                    icon: menuIcons[menu?.menuName] || '', // Use the icon dynamically based on menu name
                    subItems: menu?.menuName === "Data Analysis" ?
                        userMenu?.filter(data => data?.isDataAnalysis === true)?.map((sub) => ({
                            text: sub?.menuName,
                            path: PATH.DATA_ANALYSIS,
                        }))
                        : menu?.menuName === "Laboratory" ?
                            userMenu?.filter(data => data?.isLaboratory === true)?.map((sub) => ({
                                text: sub?.menuName,
                                path: `/${sub?.menuName.toLowerCase().replace(/\s+/g, '-')}`,
                            }))
                            : menu?.menuName === "Logistics" ?
                                userMenu?.filter(data => data?.isLogistics === true)?.map((sub) => ({
                                    text: sub?.menuName,
                                    path: `/${sub?.menuName.toLowerCase().replace(/\s+/g, '-')}`,
                                }))
                                : menu?.menuName === "Inventory" ?
                                    userMenu?.filter(data => data?.isInventory === true)?.map((sub) => ({
                                        text: sub?.menuName,
                                        path: `/${sub?.menuName.toLowerCase().replace(/\s+/g, '-')}`,
                                    })) : undefined
                }));

                setMenuItems([
                    ...mappedItems,
                ]);
            } catch (error) {
                console.error('Error fetching user menu:', error);
            } finally {
                setLoading(false);
            }
        };
    
        fetchMenu();
    }, [location.pathname]);


    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const ShowSubMenuOptions = (menu) => {

        if (menu === "Data Analysis") {
            const newValue = !dataAnalysisOpen;
            setDataAnalysisOpen(newValue);
            localStorage.setItem('openDA', JSON.stringify(newValue));
        }
        else if (menu === "Laboratory") {
            const newValue = !laboratoryOpen;
            setLaboratoryOpen(newValue);
            localStorage.setItem('openLaboratory', JSON.stringify(newValue));
        }
        else if (menu === "Logistics") {
            const newValue = !logisticsOpen;
            setLogisticsOpen(newValue);
            localStorage.setItem('openLogistics', JSON.stringify(newValue));
        }
        else if (menu === "Inventory") {
            const newValue = !inventoryOpen;
            setInventoryOpen(newValue);
            localStorage.setItem('openInventory', JSON.stringify(newValue));
        }

    };





    useEffect(() => {
        // Search in both main items and sub-items
        const previousSubItem = menuItems?.flatMap(data =>
            [data, ...(data?.subItems || [])]
        ).find(val => val?.path === location.pathname);

        // Prefer state, fallback to menu match or localStorage
        const subItemText = location.state?.stageName || previousSubItem?.text || localStorage.getItem('selectedSubItem') || '';

        // Update the selected sub-item state
        setSelectedSubItem(subItemText);
    }, [location, menuItems]);




    const handleNavigation = async (path, name, value) => {
        setSelectedItem(name);
        setSelectedSubItem(name);
        localStorage.setItem('selectedSubItem', name);

        if (name === "Logout") {
            try {
                const response = await logoutApi().unwrap();
                if (response?.result === "Success") {
                    dispatch(onLogout());
                    persistor.purge();
                    persistor.flush();
                    localStorage.clear();
                    Cookies.remove('token');
                    navigate('/');
                    displaySnackbar('success', "Thank You!");
                } else {
                    displaySnackbar('error', response?.message || 'Logout failed!');
                }
            } catch (error) {
                displaySnackbar('error', error?.data?.message || 'An error occurred during logout.');
            }
        } else {
            if (value === 'child') {
                navigate(path, {
                    state: { stageName: name }
                });
            }
            else {
                navigate(path)
            }


            if (stageMasterData.length > 0) {

                const matchingStage = stageMasterData?.find(stage => stage.stageMasterName === name);
                const stageMasterId = matchingStage?.stageMasterId;

                if (stageMasterId) {
                    dispatch(setStageMasterName(stageMasterId));
                    dispatch(setStageName(name));
                }
            }
        }
    };

    const handleProfileClick = () => {
        setSelectedItem('/profile');
        navigate(PATH.MY_PROFILE);
    }


    return (
        <Box>
            <Drawer
                variant="permanent"
                sx={{
                    ".MuiDrawer-paperAnchorDockedLeft": {
                        height: '100%',
                    },
                }}
                open={open}>
                {open ? (
                    <DrawerMainContainer>
                        <DrawerHeader
                            sx={{
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                padding: '5px 20px',
                                gap: '20px',
                            }}>
                            <Box>
                                <img
                                    src={nucliqLogo}
                                    alt="edge"
                                    style={{
                                        width: "125px",
                                        height: "60px",
                                    }}
                                />
                            </Box>
                        </DrawerHeader>

                        <Divider
                            sx={{
                                backgroundColor: 'border: 30px solid #D1D5DB',
                                marginRight: "20px",
                                marginLeft: "20px"
                            }} />


                    </DrawerMainContainer>

                ) : (
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        sx={{ ...(open && { display: "none" }) }}
                    >
                        <img src={MenuIcon} alt="Menu Icon"
                            style={{
                                width: 24,
                                height: 24,
                                marginTop: '10px',
                                marginLeft: '10px',
                            }} />
                    </IconButton>
                )}


                <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', height: "100%" }}>
                    <List>
                        {menuItems?.map((item, index) => (
                            <Box key={index} sx={{ marginLeft: '15px', marginRight: "15px" }}>
                                <ListItem disablePadding>
                                    <ListItemButton
                                        onClick={item.subItems ? () => ShowSubMenuOptions(item.text) : () => handleNavigation(item.path, item.text, 'parent')}
                                        className={(
                                            location.pathname === item.path ? 'selected' :
                                                (
                                                    location.pathname === PATH.USERS ||
                                                    location.pathname === PATH.CREATE_USER ||
                                                    location.pathname === PATH.UPDATE_USER ||
                                                    location.pathname === PATH.ROLES ||
                                                    location.pathname === PATH.UPDATE_ROLE_PERMISSION ||
                                                    location.pathname === PATH.STUDY_AND_ANALYSIS ||
                                                    location.pathname === PATH.PRODUCTS ||
                                                    location.pathname === PATH.CREATE_PRODUCTS ||
                                                    location.pathname === PATH.UPDATE_PRODUCTS ||
                                                    location.pathname === PATH.AUDIT_LOG
                                                )
                                                    && item.path === PATH.MANAGEMENT ? 'selected' :
                                                    (
                                                        location.pathname === PATH.CLIENTS ||
                                                        location.pathname === PATH.CREATE_CLIENT ||
                                                        location.pathname === PATH.UPDATE_CLIENT
                                                    )
                                                        && item.path === PATH.CLIENTS ? 'selected' :
                                                        (
                                                            location.pathname === PATH.UPDATE_ORDER ||
                                                            location.pathname === PATH.CREATE_ORDER
                                                        )
                                                            && item.path === PATH.ORDERS ? 'selected' :
                                                            (
                                                                location.pathname === PATH.BATCHES ||
                                                                location.pathname === PATH.CREATE_BATCH ||
                                                                location.pathname === PATH.UPDATE_BATCH ||
                                                                location.pathname === PATH.LIST_OF_BARCODES ||
                                                                location.pathname === PATH.CREATE_SAMPLE
                                                            )
                                                                && item.path === "/laboratory" ? 'selected' :
                                                                (location.pathname === PATH.ORDERS ||
                                                                    location.pathname === PATH.CREATE_ORDER ||
                                                                    location.pathname === PATH.UPDATE_ORDER ||
                                                                    location.pathname === PATH.KITS ||
                                                                    location.pathname === PATH.CLIENTS ||
                                                                    location.pathname === PATH.CREATE_CLIENT ||
                                                                    location.pathname === PATH.UPDATE_CLIENT)
                                                                    && item.path === "/logistics" ? 'selected' :

                                                                    (location.pathname === PATH.FREEZER ||
                                                                        location.pathname === PATH.LAB_CONSUMABLES ||
                                                                        location.pathname === PATH.GUTCHECK_SUPPLIES ||
                                                                        location.pathname === PATH.HISTORY_OF_GUTCHECK_SUPPLIES ||
                                                                        location.pathname === PATH.HISTORY_OF_LAB_CONSUMABLES)
                                                                        && item.path === "/inventory" ? 'selected' :

                                                                        (location.pathname === PATH.METADATA)
                                                                            && item.path === PATH.METADATA ? 'selected' :
                                                                            (
                                                                                location.pathname === PATH.BIOINFORMATICS ||
                                                                                location.pathname === PATH.ML_ANALYSIS ||
                                                                                location.pathname === PATH.R_ANALYSIS ||
                                                                                location.pathname === PATH.REPORT_GENERATION ||
                                                                                location.pathname === PATH.QUALITY_CONTROL ||
                                                                                location.pathname === PATH.SAMPLES_BIOINFORMATICS ||
                                                                                location.pathname === PATH.SAMPLES_ML_ANALYSIS ||
                                                                                location.pathname === PATH.SAMPLES_R_ANALYSIS ||
                                                                                location.pathname === PATH.SAMPLES_REPORT_GENERATION ||
                                                                                location.pathname === PATH.SAMPLES_QUALITY_CONTROL ||
                                                                                location.pathname === PATH.SCRIPTS ||
                                                                                location.pathname === PATH.UPLOAD_SCRIPT ||
                                                                                location.pathname === PATH.SCRIPT_HISTORY ||
                                                                                location.pathname === PATH.REPORT_TEMPLATE ||
                                                                                location.pathname === PATH.CREATE_REPORT_TEMPLATE ||
                                                                                location.pathname === PATH.UPDATE_REPORT_TEMPLATE ||
                                                                                location.pathname === PATH.REPORT_TEMPLATE_HISTORY ||
                                                                                location.pathname === PATH.DATA_CURATION ||
                                                                                location.pathname === PATH.UPLOAD_DATA_CURATION ||
                                                                                location.pathname === PATH.DATA_CURATION_HISTORY
                                                                            )
                                                                                && item.path === PATH.DATA_ANALYSIS ? 'selected' : '')}>
                                        <ListItemIcon sx={{
                                            color: selectedItem === item.text ? '#fff' : 'inherit',
                                            minWidth: 40,
                                        }}>
                                            <img src={item.icon} alt={`${item.text} Icon`} style={{ width: 24, height: 24, }} />
                                        </ListItemIcon>

                                        <ListItemText primary={item.text} />
                                        {item.subItems && (
                                            item.text === "Data Analysis"
                                                ? (dataAnalysisOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />)
                                                : item.text === "Laboratory"
                                                    ? (laboratoryOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />)
                                                    : item.text === "Logistics"
                                                        ? (logisticsOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />)
                                                        : item.text === "Inventory"
                                                            ? (inventoryOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />)
                                                            : null
                                        )}
                                    </ListItemButton>
                                </ListItem>
                                {
                                    item.subItems && (item.text === "Data Analysis") && dataAnalysisOpen && (
                                        <Collapse in={dataAnalysisOpen} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {item.subItems.map((subItem) => (
                                                    <ListItemButton
                                                        key={subItem.text}
                                                        sx={{ pl: '70px' }}
                                                        onClick={() => handleNavigation(subItem.path, subItem.text, 'child')}
                                                        className={
                                                            (location.pathname === subItem.path || location.pathname === PATH.BIOINFORMATICS || location.pathname === PATH.SAMPLES_BIOINFORMATICS ||
                                                                location.pathname === PATH.SCRIPTS || location.pathname === PATH.UPLOAD_SCRIPT || location.pathname === PATH.SCRIPT_HISTORY) && selectedSubItem === subItem.text ? 'seleted_subItem' :
                                                                (location.pathname === subItem.path || location.pathname === PATH.ML_ANALYSIS || location.pathname === PATH.SAMPLES_ML_ANALYSIS ||
                                                                    location.pathname === PATH.SCRIPTS || location.pathname === PATH.UPLOAD_SCRIPT || location.pathname === PATH.SCRIPT_HISTORY) && selectedSubItem === subItem.text ? 'seleted_subItem' :
                                                                    (location.pathname === subItem.path || location.pathname === PATH.R_ANALYSIS || location.pathname === PATH.SAMPLES_R_ANALYSIS ||
                                                                        location.pathname === PATH.SCRIPTS || location.pathname === PATH.UPLOAD_SCRIPT || location.pathname === PATH.SCRIPT_HISTORY) && selectedSubItem === subItem.text ? 'seleted_subItem' :
                                                                        (location.pathname === subItem.path || location.pathname === PATH.REPORT_GENERATION || location.pathname === PATH.SAMPLES_REPORT_GENERATION ||
                                                                            location.pathname === PATH.SCRIPTS || location.pathname === PATH.UPLOAD_SCRIPT || location.pathname === PATH.SCRIPT_HISTORY || location.pathname === PATH.REPORT_TEMPLATE ||
                                                                            location.pathname === PATH.CREATE_REPORT_TEMPLATE || location.pathname === PATH.UPDATE_REPORT_TEMPLATE || location.pathname === PATH.REPORT_TEMPLATE_HISTORY) && selectedSubItem === subItem.text ? 'seleted_subItem' :
                                                                            (location.pathname === subItem.path || location.pathname === PATH.QUALITY_CONTROL || location.pathname === PATH.SAMPLES_QUALITY_CONTROL ||
                                                                                location.pathname === PATH.SCRIPTS || location.pathname === PATH.UPLOAD_SCRIPT || location.pathname === PATH.SCRIPT_HISTORY) && selectedSubItem === subItem.text ? 'seleted_subItem' :
                                                                                (location.pathname === subItem.path || location.pathname === PATH.DATA_CURATION || location.pathname === PATH.UPLOAD_DATA_CURATION || location.pathname === PATH.DATA_CURATION_HISTORY) && selectedSubItem === subItem.text ? 'seleted_subItem' : ''
                                                        }
                                                    >
                                                        <ListItemText primary={subItem.text} />
                                                    </ListItemButton>
                                                ))}
                                            </List>
                                        </Collapse>
                                    )
                                }
                                {
                                    item.subItems && (item.text === "Laboratory") && laboratoryOpen && (
                                        <Collapse in={laboratoryOpen} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {item.subItems.map((subItem) => (
                                                    <ListItemButton
                                                        key={subItem.text}
                                                        sx={{ pl: '70px' }}
                                                        onClick={() => handleNavigation(subItem.path, subItem.text, '')}
                                                        className={
                                                            (location.pathname === subItem.path ||
                                                                location.pathname === PATH.BATCHES ||
                                                                location.pathname === PATH.CREATE_BATCH ||
                                                                location.pathname === PATH.UPDATE_BATCH ||
                                                                location.pathname === PATH.LIST_OF_BARCODES ||
                                                                location.pathname === PATH.CREATE_SAMPLE) && selectedSubItem === subItem.text ? 'seleted_subItem' : ''
                                                        }
                                                    >
                                                        <ListItemText primary={subItem.text} />
                                                    </ListItemButton>
                                                ))}
                                            </List>
                                        </Collapse>
                                    )
                                }
                                {
                                    item.subItems && (item.text === "Logistics") && logisticsOpen && (
                                        <Collapse in={logisticsOpen} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {item.subItems.map((subItem) => (
                                                    <ListItemButton
                                                        key={subItem.text}
                                                        sx={{ pl: '70px' }}
                                                        onClick={() => handleNavigation(subItem.path, subItem.text, '')}
                                                        className={
                                                            (location.pathname === subItem.path ||
                                                                location.pathname === PATH.ORDERS ||
                                                                location.pathname === PATH.CREATE_ORDER ||
                                                                location.pathname === PATH.UPDATE_ORDER ||
                                                                location.pathname === PATH.KITS ||
                                                                location.pathname === PATH.CLIENTS ||
                                                                location.pathname === PATH.CREATE_CLIENT ||
                                                                location.pathname === PATH.UPDATE_CLIENT) && selectedSubItem === subItem.text ? 'seleted_subItem' : ''
                                                        }
                                                    >
                                                        <ListItemText primary={subItem.text} />
                                                    </ListItemButton>
                                                ))}
                                            </List>
                                        </Collapse>
                                    )
                                }

                                {
                                    item.subItems && (item.text === "Inventory") && inventoryOpen && (
                                        <Collapse in={inventoryOpen} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {item.subItems.map((subItem) => (
                                                    <ListItemButton
                                                        key={subItem.text}
                                                        sx={{ pl: '70px' }}
                                                        onClick={() => handleNavigation(subItem.path, subItem.text, '')}
                                                        className={
                                                            (
                                                                location.pathname === subItem.path ||
                                                                location.pathname === PATH.FREEZER ||
                                                                location.pathname === PATH.LAB_CONSUMABLES ||
                                                                location.pathname === PATH.GUTCHECK_SUPPLIES ||
                                                                location.pathname === PATH.HISTORY_OF_GUTCHECK_SUPPLIES ||
                                                                location.pathname === PATH.HISTORY_OF_LAB_CONSUMABLES) && selectedSubItem === subItem.text ? 'seleted_subItem' : ''
                                                        }
                                                    >
                                                        <ListItemText primary={subItem.text} />
                                                    </ListItemButton>
                                                ))}
                                            </List>
                                        </Collapse>
                                    )
                                }
                            </Box>
                        ))}
                    </List>

                    <Box sx={{
                        width: '100%',
                        padding: "1px",

                    }}>

                        <List>
                            <Box sx={{ marginLeft: '15px', marginRight: "15px" }}>
                                <ListItem disablePadding>
                                    <ListItemButton onClick={() => handleNavigation('/logout', 'Logout', '')}>
                                        <ListItemIcon sx={{
                                            color: '#fff',
                                            minWidth: 40,
                                        }}>
                                            <img src={LogoutIcon} alt={`${LogoutIcon} Icon`} style={{ width: 24, height: 24, }} />
                                        </ListItemIcon>
                                        <ListItemText>Logout</ListItemText>
                                    </ListItemButton>
                                </ListItem>
                            </Box>
                        </List>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#E5E7EB',
                            padding: ' 5px 16px',
                            borderRadius: '10px',
                            marginLeft: "15px",
                            marginRight: "15px",
                            cursor: 'pointer',
                            ...(location.pathname === '/profile' && {
                                background: 'linear-gradient(92.12deg, #1378F9 0%, #17C5CD 90%)',
                                fontWeight: '600',
                            }),
                        }}
                            onClick={handleProfileClick}>
                            <Avatar sx={{ bgcolor: '#1976d2', width: 40, height: 40 }}>
                                {avatarLetter}
                            </Avatar>
                            <Box sx={{ marginLeft: '23px', }}>
                                <Typography variant="subtitle1"
                                    sx={{
                                        fontWeight: 'bold',
                                        fontSize: "16px",
                                        color: location.pathname === PATH.MY_PROFILE ? 'white' : 'black'
                                    }}>
                                    {userDetails?.userName}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    sx={{
                                        cursor: 'pointer', '&:hover': { textDecoration: 'underline' },
                                        color: location.pathname === PATH.MY_PROFILE ? 'white' : 'black',
                                        textDecoration: location.pathname === PATH.MY_PROFILE ? 'underline' : ''
                                    }}
                                >
                                    View Profile
                                </Typography>
                            </Box>
                        </Box>

                        <Box sx={{ pt: 1, textAlign: "center" }}>
                            <img
                                src={copyrightLogo}
                                alt="NUCLIQ Logo"
                                style={{ width: "200px" }}
                            />
                        </Box>

                    </Box>
                </Box>
            </Drawer >
        </Box >
    );
}




